import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/joy';
import { NotificationProvider } from '../../contexts/NotificationContext';
import NotificationContainer from '../../components/NotificationContainer';

export const OperationsApp: React.FC = () => {
  return (
    <NotificationProvider>
      <NotificationContainer />
      <Box sx={{ width: '100%', minWidth: 0, mx: 'auto', px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 2.5 }, pb: { xs: 2, sm: 3 } }}>
        <Outlet />
      </Box>
    </NotificationProvider>
  );
};